export default __webpack_public_path__ + "static/media/apple.58ea8ec9.svg";